import { render, staticRenderFns } from "./upBonusPopup.vue?vue&type=template&id=0ac67c0b&scoped=true"
import script from "./upBonusPopup.vue?vue&type=script&lang=js"
export * from "./upBonusPopup.vue?vue&type=script&lang=js"
import style0 from "./upBonusPopup.vue?vue&type=style&index=0&id=0ac67c0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac67c0b",
  null
  
)

export default component.exports